var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiaImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3765_7158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.361328H31.2V7.19499H0V0.361328Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.19519H31.2V14.0289H0V7.19519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0291H31.2V20.8628H0V14.0291Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 13.3457C17.3234 13.3457 18.7202 12.1218 18.7202 10.6122C18.7202 9.10254 17.3234 7.87872 15.6002 7.87872C13.8771 7.87872 12.4802 9.10254 12.4802 10.6122C12.4802 12.1218 13.8771 13.3457 15.6002 13.3457Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 13.0038C17.1076 13.0038 18.3299 11.9329 18.3299 10.612C18.3299 9.29105 17.1076 8.22021 15.5999 8.22021C14.0921 8.22021 12.8699 9.29105 12.8699 10.612C12.8699 11.9329 14.0921 13.0038 15.5999 13.0038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 11.0901C15.9017 11.0901 16.1462 10.8759 16.1462 10.6117C16.1462 10.3475 15.9017 10.1334 15.6002 10.1334C15.2987 10.1334 15.0542 10.3475 15.0542 10.6117C15.0542 10.8759 15.2987 11.0901 15.6002 11.0901Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2888 11.0464C18.3657 11.0553 18.4362 11.0079 18.4464 10.9405C18.4565 10.8731 18.4024 10.8114 18.3255 10.8025C18.2486 10.7936 18.1781 10.841 18.168 10.9084C18.1578 10.9757 18.2119 11.0375 18.2888 11.0464Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6004 13.0027L15.694 11.5676L15.6004 10.8842L15.5068 11.5676L15.6004 13.0027Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0654 11.643C18.1353 11.6675 18.2174 11.6354 18.2489 11.5712C18.2803 11.507 18.2491 11.4351 18.1793 11.4105C18.1094 11.3859 18.0273 11.4181 17.9958 11.4823C17.9644 11.5465 17.9955 11.6184 18.0654 11.643Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8861 12.9242L15.4032 11.5539L15.5275 10.8734L15.2379 11.516L14.8861 12.9242Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6767 12.1695C17.7364 12.2093 17.8245 12.1966 17.8736 12.1412C17.9226 12.0857 17.9139 12.0085 17.8542 11.9687C17.7945 11.9289 17.7064 11.9415 17.6573 11.997C17.6083 12.0524 17.617 12.1296 17.6767 12.1695Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2298 12.6871L15.1317 11.4786L15.4492 10.8468L14.9799 11.4023L14.2298 12.6871Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1467 12.5884C17.1923 12.641 17.2804 12.6489 17.3435 12.6062C17.4067 12.5635 17.4209 12.4863 17.3753 12.4338C17.3297 12.3812 17.2416 12.3732 17.1784 12.416C17.1153 12.4587 17.1011 12.5359 17.1467 12.5884Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6658 12.3068L14.8915 11.3431L15.3825 10.803L14.766 11.233L13.6658 12.3068Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5181 12.8662C16.5497 12.9306 16.6318 12.9632 16.7015 12.9389C16.7712 12.9146 16.802 12.8426 16.7704 12.7782C16.7388 12.7137 16.6566 12.6811 16.587 12.7054C16.5173 12.7297 16.4864 12.8017 16.5181 12.8662Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2397 11.8025L14.7038 11.1675L15.3267 10.7531L14.6031 11.0157L13.2397 11.8025Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8198 12.9961C15.8318 13.0652 15.9024 13.1154 15.9773 13.1083C16.0522 13.1012 16.1032 13.0394 16.0912 12.9703C16.0791 12.9012 16.0086 12.8509 15.9336 12.858C15.8587 12.8652 15.8077 12.927 15.8198 12.9961Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9661 11.2231L14.5715 10.9487L15.2962 10.6899L14.5176 10.7752L12.9661 11.2231Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 12.9646C15.0918 13.0303 15.1494 13.0921 15.2284 13.1026C15.3075 13.113 15.378 13.0682 15.386 13.0024C15.3939 12.9367 15.3363 12.8749 15.2573 12.8644C15.1783 12.854 15.1077 12.8988 15.0998 12.9646Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8732 10.5903L14.5102 10.6798L15.2856 10.6325L14.5045 10.5579L12.8732 10.5903Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4241 12.7725C14.3954 12.8346 14.431 12.9066 14.5036 12.9332C14.5762 12.9598 14.6584 12.931 14.6871 12.8689C14.7158 12.8067 14.6801 12.7348 14.6075 12.7082C14.5349 12.6815 14.4528 12.7103 14.4241 12.7725Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9626 9.98854L14.5242 10.4402L15.3013 10.5425L14.5696 10.2874L12.9626 9.98854Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8294 12.4373C13.7803 12.4928 13.7889 12.57 13.8486 12.6098C13.9083 12.6496 13.9964 12.6368 14.0455 12.5814C14.0945 12.5259 14.0859 12.4487 14.0262 12.4089C13.9666 12.3691 13.8784 12.3818 13.8294 12.4373Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2394 9.42162L14.6028 10.2084L15.3264 10.4711L14.7035 10.0566L13.2394 9.42162Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3516 11.9713C13.2883 12.0142 13.2737 12.0914 13.319 12.1437C13.3644 12.1961 13.4525 12.2037 13.5159 12.1608C13.5792 12.1179 13.5939 12.0407 13.5485 11.9884C13.5032 11.936 13.415 11.9284 13.3516 11.9713Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6738 8.92343L14.7559 9.9949L15.3751 10.4143L14.8967 9.87181L13.6738 8.92343Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0264 11.416C12.9533 11.4431 12.917 11.5151 12.9452 11.5767C12.9735 11.6383 13.0556 11.6663 13.1287 11.6391C13.2017 11.612 13.2381 11.54 13.2099 11.4784C13.1816 11.4168 13.0995 11.3888 13.0264 11.416Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2392 8.54307L14.9674 9.82616L15.44 10.3736L15.1378 9.74007L14.2392 8.54307Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8776 10.8039C12.7993 10.8138 12.7427 10.8756 12.7514 10.9419C12.76 11.0081 12.8305 11.0537 12.9089 11.0437C12.9873 11.0337 13.0438 10.9719 13.0351 10.9057C13.0265 10.8395 12.956 10.7939 12.8776 10.8039Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8997 8.30327L15.2184 9.71011L15.5129 10.3464L15.4118 9.66453L14.8997 8.30327Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9159 10.1719C12.8412 10.1645 12.7707 10.2145 12.7584 10.2834C12.7461 10.3523 12.7967 10.4141 12.8714 10.4214C12.946 10.4287 13.0166 10.3788 13.0289 10.3099C13.0412 10.241 12.9906 10.1792 12.9159 10.1719Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.628 8.21956L15.5246 9.6539L15.5727 10.3339L15.6565 9.6498L15.628 8.21956Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1357 9.57851C13.0659 9.55388 12.9837 9.5859 12.9522 9.65004C12.9207 9.71417 12.9518 9.78612 13.0216 9.81075C13.0914 9.83538 13.1735 9.80336 13.205 9.73923C13.2365 9.6751 13.2055 9.60314 13.1357 9.57851Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3152 8.29731L15.798 9.66733L15.6733 10.3479L15.9627 9.70547L16.3152 8.29731Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.524 9.05343C13.4644 9.01359 13.3763 9.02622 13.3272 9.08163C13.278 9.13704 13.2866 9.21426 13.3462 9.2541C13.4058 9.29394 13.4939 9.28131 13.543 9.2259C13.5921 9.17049 13.5836 9.09327 13.524 9.05343Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9709 8.53584L16.0689 9.7442L15.751 10.376L16.2202 9.82064L16.9709 8.53584Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0536 8.63443C14.0083 8.58202 13.9201 8.57425 13.8567 8.61708C13.7933 8.65991 13.7787 8.73713 13.824 8.78955C13.8693 8.84197 13.9574 8.84974 14.0208 8.8069C14.0842 8.76407 14.0989 8.68685 14.0536 8.63443Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5345 8.91606L16.3086 9.88039L15.8165 10.4204L16.4328 9.98993L17.5345 8.91606Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6824 8.3559C14.6507 8.29143 14.5686 8.25888 14.4989 8.28317C14.4292 8.30747 14.3984 8.37943 14.43 8.44389C14.4617 8.50835 14.5438 8.54091 14.6135 8.51661C14.6831 8.49231 14.714 8.42036 14.6824 8.3559Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9608 9.41952L16.4967 10.0545L15.8738 10.469L16.5973 10.2063L17.9608 9.41952Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3807 8.22758C15.3686 8.15848 15.2981 8.10823 15.2231 8.11535C15.1482 8.12247 15.0972 8.18425 15.1093 8.25336C15.1213 8.32246 15.1919 8.37271 15.2668 8.36559C15.3417 8.35847 15.3927 8.29669 15.3807 8.22758Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2344 10.0005L16.6289 10.275L15.9042 10.5337L16.6828 10.4485L18.2344 10.0005Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1011 8.25743C16.1088 8.19192 16.0508 8.13013 15.9716 8.11942C15.8923 8.10872 15.8218 8.15315 15.8141 8.21866C15.8063 8.28417 15.8643 8.34596 15.9436 8.35667C16.0228 8.36738 16.0933 8.32295 16.1011 8.25743Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3273 10.6339L16.6904 10.5435L15.9156 10.5868L16.6967 10.6605L18.3273 10.6339Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7782 8.4502C16.8065 8.38836 16.7704 8.3164 16.6974 8.28949C16.6245 8.26258 16.5424 8.29089 16.514 8.35274C16.4856 8.41459 16.5218 8.48654 16.5947 8.51345C16.6677 8.54037 16.7498 8.51205 16.7782 8.4502Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2393 11.234L16.6765 10.7819L15.8996 10.6774L16.6322 10.932L18.2393 11.234Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3759 8.79022C17.4221 8.73708 17.409 8.65986 17.3465 8.61775C17.2841 8.57564 17.1959 8.58458 17.1497 8.63773C17.1034 8.69087 17.1166 8.76808 17.179 8.81019C17.2415 8.8523 17.3296 8.84336 17.3759 8.79022Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9659 11.8095L16.59 11.0202L15.8683 10.7459L16.4999 11.1578L17.9659 11.8095Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8536 9.25435C17.9142 9.21376 17.9243 9.13654 17.8761 9.08188C17.8279 9.02721 17.7398 9.0158 17.6792 9.05639C17.6187 9.09698 17.6086 9.1742 17.6568 9.22886C17.7049 9.28352 17.7931 9.29493 17.8536 9.25435Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5327 12.304L16.4357 11.2306L15.8187 10.8026L16.3075 11.3432L17.5327 12.304Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.178 9.81247C18.2488 9.78721 18.2813 9.71526 18.2507 9.65175C18.2201 9.58825 18.138 9.55725 18.0673 9.5825C17.9965 9.60776 17.964 9.67971 17.9946 9.74322C18.0252 9.80672 18.1073 9.83773 18.178 9.81247Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9674 12.6851L16.2235 11.4008L15.7534 10.8479L16.0664 11.4803L16.9674 12.6851Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3267 10.422C18.4026 10.4139 18.4553 10.3521 18.4442 10.284C18.4332 10.2159 18.3627 10.1673 18.2867 10.1754C18.2108 10.1835 18.1581 10.2453 18.1692 10.3134C18.1802 10.3815 18.2507 10.4301 18.3267 10.422Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3104 12.9215L15.9684 11.5137L15.6774 10.8732L15.7948 11.5542L16.3104 12.9215Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3765_7158"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.361328,
    width: 31.2,
    height: 20.501,
    rx: 5.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaImage);
export default __webpack_public_path__ + "static/media/indiaImage.3c66e9e33b1ff35d60f65b44a3c7823b.svg";
export { ForwardRef as ReactComponent };